import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Elements } from 'react-stripe-elements';
import { Heading } from '@components/common';
import DialogBox from '@components/DialogBox';
import { MobileContainer } from '@containers/layout';
import SingleCheckoutForm from './SingleCheckoutForm';
import RecurringCheckoutForm from './RecurringCheckoutForm';
import CancelConfirm from './CancelConfirm';
import BookingActions, { BookingSelectors } from '@redux/BookingRedux';
import ScheduleActions from '@redux/ScheduleRedux';
import { FREQUENCIES } from '@services/minte';
import { unload as unloadPixel } from '@services/pixel';

function Confirm(props) {
  const { selectedFrequency, cancelBooking, onSubmit } = props;
  const [show, toggleModal] = useState(false);

  useEffect(() => {
    return () => unloadPixel();
  }, []);

  const handleCancel = () => {
    handleDissmisModal();
    cancelBooking();
  };

  const handleShowModal = () => {
    toggleModal(true);
  };

  const handleDissmisModal = () => {
    toggleModal(false);
  };

  const renderSingle = () => (
    <SingleCheckoutForm onSubmit={onSubmit} onCancel={handleShowModal} />
  );
  const renderRecurring = () => (
    <RecurringCheckoutForm onSubmit={onSubmit} onCancel={handleShowModal} />
  );

  return (
    <MobileContainer
      pt={[0, selectedFrequency === FREQUENCIES.REGULARLY ? 6 : 0]}
    >
      <Heading px={2} mb={4} mt={0}>
        Confirm Booking
      </Heading>

      <Elements>
        {selectedFrequency !== FREQUENCIES.REGULARLY
          ? renderSingle()
          : renderRecurring()}
      </Elements>

      <DialogBox show={show} onClickOutside={handleDissmisModal}>
        <CancelConfirm onSubmit={handleCancel} onCancel={handleDissmisModal} />
      </DialogBox>
    </MobileContainer>
  );
}

Confirm.propTypes = {
  selectedFrequency: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  cancelBooking: PropTypes.func
};

const mapStatesToProps = state => ({
  selectedFrequency: BookingSelectors.selectFrequency(state)
});

const mapDispatchToProps = dispatch => ({
  cancelBooking: () => {
    dispatch(BookingActions.resetBooking(true));
    dispatch(ScheduleActions.resetRecurringBooking());
  }
});

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(Confirm);
